import script from "./ProfileCompanyDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileCompanyDrawer.vue?vue&type=script&setup=true&lang=js"

import "./ProfileCompanyDrawer.vue?vue&type=style&index=0&id=a9f2c43e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9f2c43e"]])

export default __exports__